// src/league-routes.ts
var LEAGUE_MODULE_NAMES = /* @__PURE__ */ ((LEAGUE_MODULE_NAMES3) => {
  LEAGUE_MODULE_NAMES3["assessment"] = "assessment";
  LEAGUE_MODULE_NAMES3["benefits"] = "benefits";
  LEAGUE_MODULE_NAMES3["careCollections"] = "care-collections";
  LEAGUE_MODULE_NAMES3["careDiscovery"] = "care-discovery";
  LEAGUE_MODULE_NAMES3["careDocuments"] = "care-documents";
  LEAGUE_MODULE_NAMES3["careFinder"] = "care-finder";
  LEAGUE_MODULE_NAMES3["careLibrary"] = "care-library";
  LEAGUE_MODULE_NAMES3["caregiver"] = "caregiver";
  LEAGUE_MODULE_NAMES3["wallet"] = "wallet";
  LEAGUE_MODULE_NAMES3["healthJourney"] = "health-journey";
  LEAGUE_MODULE_NAMES3["healthJourneyHistory"] = "health-journey-history";
  LEAGUE_MODULE_NAMES3["healthNeedPages"] = "health-need-pages";
  LEAGUE_MODULE_NAMES3["healthProfile"] = "health-profile";
  LEAGUE_MODULE_NAMES3["healthPrograms"] = "health-programs";
  LEAGUE_MODULE_NAMES3["healthProgress"] = "health-progress";
  LEAGUE_MODULE_NAMES3["messaging"] = "messaging";
  LEAGUE_MODULE_NAMES3["onboarding"] = "onboarding";
  LEAGUE_MODULE_NAMES3["rewardsAchievements"] = "achievements";
  LEAGUE_MODULE_NAMES3["aboutMe"] = "about-me";
  LEAGUE_MODULE_NAMES3["claims"] = "claims";
  LEAGUE_MODULE_NAMES3["liveChat"] = "live-chat";
  LEAGUE_MODULE_NAMES3["home"] = "home";
  return LEAGUE_MODULE_NAMES3;
})(LEAGUE_MODULE_NAMES || {});
var leagueRoutesMap = {
  ["assessment" /* assessment */]: "/health-profile/questions",
  ["care-collections" /* careCollections */]: "/care-collections",
  ["care-discovery" /* careDiscovery */]: "/get-care",
  ["care-documents" /* careDocuments */]: "/documents",
  ["care-finder" /* careFinder */]: "/care-finder",
  ["care-library" /* careLibrary */]: "/care-library",
  ["caregiver" /* caregiver */]: "/caregiver",
  ["benefits" /* benefits */]: "/benefits",
  ["wallet" /* wallet */]: "/wallet",
  ["health-journey" /* healthJourney */]: "/health-journey",
  ["health-journey-history" /* healthJourneyHistory */]: "/health-history",
  ["health-need-pages" /* healthNeedPages */]: "/health-need",
  ["health-profile" /* healthProfile */]: "/health-profile",
  ["health-programs" /* healthPrograms */]: "/health-programs",
  ["health-progress" /* healthProgress */]: "/health-progress",
  ["messaging" /* messaging */]: "/messaging",
  ["onboarding" /* onboarding */]: "/onboarding",
  ["achievements" /* rewardsAchievements */]: "/achievements",
  ["about-me" /* aboutMe */]: "/about-me",
  ["claims" /* claims */]: "/claims",
  ["live-chat" /* liveChat */]: "/live-chat",
  ["home" /* home */]: "/home"
};

// src/league-routes.util.ts
var checkModuleMapExists = (moduleName) => {
  if (!Object.keys(leagueRoutesMap).includes(moduleName))
    throw Error("Passed in module name has not been mapped to a path.");
};
var getModulePath = (moduleName) => {
  checkModuleMapExists(moduleName);
  return leagueRoutesMap[moduleName];
};
var setModulePath = (moduleName, path) => {
  checkModuleMapExists(moduleName);
  leagueRoutesMap[moduleName] = path;
};
var overwriteRoutePaths = (overrideRouteMap) => {
  Object.keys(overrideRouteMap).forEach((key) => {
    const moduleName = key;
    const value = overrideRouteMap[moduleName];
    if (value) {
      setModulePath(moduleName, value);
    }
  });
};
export {
  LEAGUE_MODULE_NAMES,
  getModulePath,
  leagueRoutesMap,
  overwriteRoutePaths,
  setModulePath
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/league-routes'] = window.leagueSDKsPresent['@leagueplatform/league-routes'] || [];
    window.leagueSDKsPresent['@leagueplatform/league-routes'].push('2.23.5');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/league-routes'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/league-routes module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map